import React from "react";
import { ServiceContext } from "./Provider";

export const useServices = () => React.useContext(ServiceContext);
